import { muiComponentsMiscControls } from './muiComponentsMiscControls'
import { muiComponentsMiscSurfaces } from './muiComponentsMiscSurfaces'

export const muiComponentsMisc = {
  ...muiComponentsMiscControls,
  ...muiComponentsMiscSurfaces,
}
